<template>
  <div class="role-apply-panel" v-loading="loading">
    <div class="permissionsBox" v-if="options.length > 0">
      <b>可选审批人（上级部门）：</b>
      <div class="scroll-box leader-box">
        <el-checkbox-group v-model="selectLeaders">
          <el-checkbox v-for="leader in leaders" :label="leader" :key="`${leader.id}+${leader.dept_id}`">
            {{ leader.name }}『{{ leader.dept_name || '暂无部位' }} - {{ leader.position || '暂无职位' }}』
          </el-checkbox>
        </el-checkbox-group>
      </div>
      <b>可申请角色：</b>
      <el-tooltip content="仅支持向直属上级申请其可授权的角色！！！！" placement="right" effect="light">
        <span class="el-icon-info apply-tip"></span>
      </el-tooltip>
      <div class="scroll-box role-box">
        <el-checkbox-group v-model="selectRole" @change="handleSelectRole">
          <el-checkbox v-for="(item, index) in options" :key="index" :label="item.id" class="role-checkbox">
            {{ item.display_name }}
          </el-checkbox>
        </el-checkbox-group>
      </div>
    </div>
    <div class="empty-apply" v-else>暂无可申请的角色</div>

    <div class="apply-actions">
      <el-button
        round
        type="primary"
        size="mini"
        @click="submit()"
        :disabled="loadingCommit || (selectRole.length === 0 || selectLeaders.length === 0)">
        角色申请（{{ selectRole.length }}）
      </el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserComponentsRoleApplyPanel',
  data() {
    return {
      loading: false,
      loadingCommit: false,
      options: [],
      leaders: [],
      formData: {
        selectRole: []
      },
      selectLeaders: [],
      selectRole: []
    }
  },
  methods: {
    async getList() {
      this.loading = true
      const { leaders, roleList } = await this.$api.getMyApplyRoleList()
      const newRole = []
      if (roleList && roleList.length > 0) {
        roleList.forEach((item) => {
          if (item?.children.length > 0) {
            item.children.forEach((i) => {
              const pos = newRole.findIndex(value => value.id === i.id)
              if (pos === -1) {
                i.display_name = `${i.display_name}`
                newRole.push(i)
              }
            })
          }
          delete item.children
        })
      }
      this.options = newRole
      this.leaders = leaders
      setTimeout(() => {
        this.loading = false
      }, 50)
    },
    handleSelectRole(data) {
      this.formData.selectRole = this.options.map((item) => {
        if (data.find(i => {
          return i == item.id
        })) {
          return item
        } else return null
      }).filter(Boolean)
    },
    submit() {
      if (this.selectLeaders.length === 0) {
        this.$notify.warning('请先勾选审批人！！！')
        return false
      }
      if (this.selectRole.length === 0) {
        this.$notify.warning('请先勾选申请的角色！！！')
        return false
      }
      this.loadingCommit = true
      const leaderNames = this.selectLeaders.map((i) => `${i.name}『${i.dept_name || ''}』`)
      const roleNames = this.formData.selectRole.map((i) => i.display_name)
      const applyMsg = `此操作将向【${leaderNames.join('、')}】申请系统角色：【${roleNames.join('、')}】，确认提交申请？`
      this.$confirm(applyMsg, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.handleCommitApply(this.selectRole)
        this.loadingCommit = false
      })
        .catch(() => {
          this.$notify.info('已取消')
          this.loadingCommit = false
        })
    },
    async handleCommitApply(selectRole) {
      const data = await this.$api.postCommitApply(selectRole, this.selectLeaders)
      if (data) {
        this.msgSuccess('已提交申请，请耐心等待审批结果！！！')
      }
    }
  },
  mounted() {
    this.getList()
  }
}
</script>

<style lang="scss" scoped>
.role-apply-panel {
  min-height: 280px;
  text-align: left;
}

.permissionsBox {
  min-height: 220px;
  padding: 18px 20px;
  background: #fbfcfe;
  border: 1px solid #edf1f6;
  border-radius: 8px;
  box-sizing: border-box;
  text-align: left;

  > b {
    display: inline-block;
    min-width: 88px;
    color: #344054;
    font-size: 13px;
    font-weight: 600;
    margin: 8px 0;
  }
}

.scroll-box {
  overflow-y: auto;
  padding: 6px 2px;
  box-sizing: border-box;
}

.leader-box {
  max-height: 100px;
}

.role-box {
  max-height: 200px;
}

.role-checkbox {
  display: block;
  margin-bottom: 6px;
}

.apply-tip {
  color: #ff3176;
  font-size: 14px;
}

.empty-apply {
  min-height: 180px;
  padding: 28px 20px;
  color: #909399;
  background: #fbfcfe;
  border: 1px dashed #d8dee9;
  border-radius: 8px;
  box-sizing: border-box;
}

.apply-actions {
  display: block;
  width: 100%;
  margin-top: 14px;
  text-align: center;
}
</style>
